<template>
  <div v-if="row.editing && (userRole === 'Admin' || userRole === 'SuperAdmin')" class="form-group mb-0">
    <select class="form-control" v-model="row.membership_type_id" :required="row.editing" :readonly="!row.editing">
      <option disabled></option>
      <option v-for="(membershipType, membershipIndex) in row.membership_options" :key="'membershipType' + membershipIndex" :value="membershipType.id">{{membershipType.name}}</option>
    </select>
    <div class="invalid-tooltip">Please include the Membership Type.</div>
  </div>
  <span v-else>{{ row.membership_options.find(option => option.id === row.membership_type_id).name }}</span> 
</template>

<script>
export default {
  props: ['row'],
  data() {
    return {
      userRole: localStorage.role
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Tabs/MembershipHistoryFields/MembershipType.vue